import { reduxForm } from 'redux-form';
import React from 'react';
import PropTypes from 'constants/PropTypes';
import { i18n } from 'libs/i18n';
import FeedbackMessage from 'components/FeedbackMessage';
import SimpleField from 'components/Form/SimpleField';
import { createValidator, required, email } from 'validation/';

const forgotPasswordValidation = createValidator({
    email: [required(true), email],
});

export const ForgotPasswordForm = (props) => {
    const { handleSubmit, submitForm, loading, error } = props;
    return (
        <div className="ofx-forgot-username">
            <h1 className="panel-header border-1 border-bottom border-primary  uia-forgot-password-heading">
                {i18n('forgot-password')}
            </h1>
            <div className="info">{i18n('forgot-password-info')}</div>
            <form className="form" onSubmit={handleSubmit(submitForm)} noValidate>
                <FeedbackMessage message={error} visible={error !== undefined} type="error" />
                <SimpleField
                    componentType="input"
                    name="email"
                    label={i18n('email')}
                    placeholder={i18n('email')}
                    required
                    type="email"
                    id="email"
                />
                <div className="form-group form-btn-group">
                    <button
                        type="submit"
                        className="btn btn-primary uia-submit-button"
                        disabled={loading}
                    >
                        {i18n('submit')}
                    </button>
                </div>
            </form>
        </div>
    );
};

ForgotPasswordForm.propTypes = {
    submitForm: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    error: PropTypes.any,
};

export default reduxForm({
    form: 'forgotPasswordForm',
    validate: forgotPasswordValidation,
})(ForgotPasswordForm);
